<template>
  <div class="container mt-5" style="max-width: 420px;">
    <div class="card shadow-sm">
      <div class="card-body p-4">
        <h4 class="card-title text-center mb-4 fw-bold">로그인</h4>

        <div class="mb-3">
          <label class="form-label">아이디</label>
          <input
            v-model="form.username"
            type="text"
            class="form-control"
            placeholder="아이디를 입력하세요"
            @keyup.enter="login"
          />
        </div>

        <div class="mb-4">
          <label class="form-label">비밀번호</label>
          <input
            v-model="form.password"
            type="password"
            class="form-control"
            placeholder="비밀번호를 입력하세요"
            @keyup.enter="login"
          />
        </div>

        <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

        <button
          class="btn btn-dark w-100 mb-2"
          :disabled="loading"
          @click="login"
        >
          {{ loading ? '로그인 중...' : '로그인' }}
        </button>
        <button
          class="btn btn-outline-secondary w-100"
          @click="$router.push('/membership-terms')"
        >
          회원가입
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      error: null
    }
  },
  methods: {
    async login() {
      this.error = null
      if (!this.form.username || !this.form.password) {
        this.error = '아이디와 비밀번호를 입력하세요.'
        return
      }
      this.loading = true
      try {
        const res = await axios.post(`${process.env.VUE_APP_API_BASE}/api/login`, this.form)
        sessionStorage.setItem('user', JSON.stringify(res.data))
        // notify navbar about auth change
        try { window.dispatchEvent(new Event('user-auth-changed')) } catch (e) { /* ignore */ }
        this.$router.push('/')
      } catch (e) {
        this.error = e.response?.data?.message || '로그인에 실패했습니다.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
